import { AllowedMaterialSpec, MaterialComponentCategory } from 'api';
import { MaterialSupportedComponentList } from 'features';
import {
  AllowedMaterialSpecAutocomplete,
  BooleanSelectField,
  CountryAutocompleteField,
  MaterialCreationProcessSelectField,
  MaterialGradeAutocomplete,
  MaterialOriginAutocomplete,
  useFormContext,
  useWatch,
} from 'form';
import { useTranslation } from 'i18n';
import { Alert } from 'ui';

import { MaterialProductFormValues } from '../../pages/schema';

export const MaterialProductFormSections = () => {
  const { t } = useTranslation('orders');
  const form = useFormContext<MaterialProductFormValues>();
  const { formState, setValue } = form;
  // @ts-expect-error non_field_errors should exist
  const nonFieldError = formState.errors?.non_field_errors?.message;
  const [materialId, materialColourId] = useWatch({
    control: form.control,
    name: ['material_id', 'material_colour_id'],
  });
  const onMaterialSpecChange = (materialSpec: AllowedMaterialSpec) => {
    setValue('material_id', materialSpec.material_id);
    setValue('material_colour_id', materialSpec.colour_id ?? undefined);
  };

  return (
    <>
      {nonFieldError ? <Alert severity="error">{nonFieldError.toString()}</Alert> : null}
      <CountryAutocompleteField name="country" label={t('materialProducts.form.labels.country')} required />
      <AllowedMaterialSpecAutocomplete
        name="material_spec_id"
        label={t('materialProducts.form.labels.materialSpec')}
        required
        onSelectOption={onMaterialSpecChange}
      />
      <MaterialGradeAutocomplete
        name="material_grade_id"
        label={t('materialProducts.form.labels.materialGrade')}
        required
      />
      <MaterialOriginAutocomplete name="material_origin_id" label={t('materialProducts.form.labels.materialOrigin')} />
      <MaterialCreationProcessSelectField
        data-testid="material-creation-process"
        label={t('materialProducts.form.labels.materialCreationProcess')}
      />
      <BooleanSelectField
        label={t('materialProducts.form.labels.foodGrade')}
        name="is_food_grade"
        withNotAvailable
        data-testid={'food-grade'}
      />
      <BooleanSelectField
        label={t('materialProducts.form.labels.containsCapsAndLabels')}
        name="has_caps_and_labels"
        withNotAvailable
        data-testid={'caps-and-labels'}
      />
      <MaterialSupportedComponentList
        materialId={materialId}
        materialColourId={materialColourId}
        name="seller_material_component_values"
        category={MaterialComponentCategory.MATERIAL_QUALITY}
        title={t('materialProducts.form.sections.sellerMaterialComponents')}
        buttonText={t('materialProducts.form.actions.addSellerMaterialComponent')}
      />
      <MaterialSupportedComponentList
        materialId={materialId}
        materialColourId={materialColourId}
        name="buyer_material_component_values"
        category={MaterialComponentCategory.MATERIAL_QUALITY}
        title={t('materialProducts.form.sections.buyerMaterialComponents')}
        buttonText={t('materialProducts.form.actions.addBuyerMaterialComponent')}
      />
    </>
  );
};
